import React, { Component } from 'react'
import moment from 'moment'


export default class SimulationListItem extends Component {
    constructor(props) {
        super(props)
        this.state = {
            wsToClientTimerFlag: false
        }
    }

    render() {
        const { requirementid, requirementname, starttime, completecondition, submitDate, taskNumbers } = this.props.item
        const { expendId, setExpend } = this.props
        return (
            <div className='order-produce-list-item'>
                <div className='order-produce-list-item-unit'>
                    <span className='order-produce-list-item-title'>{requirementid}</span>
                </div>
                <div className='order-produce-list-item-split' />
                <div className='order-produce-list-item-unit'>
                    <div>
                        <span className='order-produce-list-item-text1'>源数据名称：{ requirementname}</span>
                        <span className='order-produce-list-item-text1'>{completecondition}</span>
                    </div>
                    <span className='order-produce-list-item-text2'>下单时间：{moment(starttime).format("yyyy-MM-DD")}</span>
                </div>
            </div>
        )
    }
}
